import { defaultsDeep } from "lodash";

const DEF_OPTS = {
    "link_url": "/documenti",
    "link_params": null,
    "api_url": "/api",
    "starting_query": null,
    "global_filters": [],
    "storage_id": null,
    "storage_enabled": false,
    "page_size": 10,
    "advanced_fields": [],
    "facets": [],
    "funds": [],
    "selected_fund": "all",
    "disable": {
        "search": false,
        "year_filter": false,
        "funds": false,
        "reset": false
    },
    "title": "",
    "minimal": false,
    "change_page_on_fondo": true,
    "csrf_header": "",
    "csrf_value": ""
};

function isSessionStorageSupported() {
    try {
        const storage = window.sessionStorage;
        storage.setItem('storage_test', 'test');
        storage.removeItem('storage_test');
        return true;
    } catch (e) {
        return false;
    }
}

const OPTS = defaultsDeep({}, window.SEARCH_OPTIONS, DEF_OPTS);
OPTS.storage_supported = isSessionStorageSupported()
OPTS.storage_enabled = OPTS.storage_supported && OPTS.storage_id && OPTS.storage_enabled;

export default OPTS;